import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC} from 'react';

export interface StackLine {
  method?: string;
  path?: string;
  lastPathElement?: string;
  lines?: string;
}

export function toStackLine(s: string): JSX.Element {
  try {
    const sa = s.split(/@|\sin\s|\sat\s/);
    const sb = sa[1].split(':');
    const path = sb[0].split('/');
    const lastPathElement = path.pop();
    const sl: StackLine = {
      method: sa[0],
      path: path.join('/'),
      lastPathElement: lastPathElement,
      lines: sb[1]
    };
    return <div>
      <span className="text-m-brand-red">{sl.method}</span>
      &nbsp;
      <span className="text-m-gray-6">{sl.path}</span>/
      <span className="text-m-green">{sl.lastPathElement}</span>
      {sl.lines && sl.lines!=='l' && <>:
        <span className="text-m-gray-6">{sl.lines}</span>
      </>}
    </div>;
  } catch (e) {
    console.debug('Error when parsing stack', e);
    return <div>{s}</div>;
  }
}

export const FlatDetailsStackTrace: FC<{ stackTrace: string[] }> = observer(({stackTrace}) => {

  return <ol style={{listStyle: 'decimal'}} className="ml-4">
    {stackTrace.map((s, i) => (
      <li key={'stackelement' + i} className="p-0">
        <div className="flex break-all">
          <span className="">{toStackLine(s)}</span>
        </div>
      </li>
    ))}
  </ol>;
});
